import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * for this page
 */
import ScylTable from './scylTable';
import MrtsTable from './mrtsTable';
import RankTable from './rankTable';
import HygnTable from './hygnTable';
import YdjkTable from './ydjkTable';
import ZldtTable from './zldtTable';
import LhbTable from './lhbTable';

class RightCon extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    /**
     * 渲染组件
     */
    render() {
        const { isOpen } = this.props;
        const { scyl, mrts, rank, hygn, ydjk, zldt, lhb } = this.props.content;

        return (
            <div className={styles.rightCon}>
                <ScylTable content={scyl} isOpen={isOpen} />
                {mrts.data && <MrtsTable content={mrts} />}
                {<RankTable content={rank} isOpen={isOpen} />}
                {<HygnTable content={hygn} isOpen={isOpen} />}
                {<YdjkTable content={ydjk} isOpen={isOpen} />}
                {<ZldtTable content={zldt} isOpen={isOpen} />}
                {lhb.data && <LhbTable content={lhb} />}
            </div>
        );
    }
}

export default errorBoundary(RightCon);
